<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss" src="@/styles/index.scss"></style>
<style lang="scss">
.m0 {
  margin: 0;
}
</style>
